<template lang="pug">
#business.custom-container
  .section-title Empresas
  b-breadcrumb.breadcrumb(:items="breadcrumbs")
  ListBusiness
</template>
<script>
import ListBusiness from "../components/business/ListBusiness";
export default {
  data(){
    return{
      breadcrumbs: [
        {
          text: 'Inicio',
          to: { name: 'Home' }
        },
        {
          text: 'Empresas',
          active:true
        },
      ]
    }
  },
  components: {
    ListBusiness,
  },
};
</script>
